export default {
    Connectors: 'Connectors',
    Dashboard: 'Dashboard',
    Messages: 'Messages',
    Mappings: 'Mappings',
    Workflows: 'Workflows',
    Schedules: 'Schedules',
    'Lookup Tables': 'Lookup Tables',
    Instances: 'Instances',
    Teams: 'Teams',
    Admin: 'Admin',
}